export const INITIAL_CATEGORIES_REQUEST = "INITIAL_CATEGORIES_REQUEST";
export const FETCH_CATEGORIES_SUCCESS = "FETCH_CATEGORIES_SUCCESS";
